<template>
  <div class="settings-page">
    <app-view-layout
      header="Zarządzanie użytkownikami"
      fluid
    >
      <template #toolbarMenu>
        <v-btn
          depressed
          color="primary"
          @click="showCreateUserModal"
        >
          Utwórz konto
        </v-btn>
      </template>
      <template #content>
        <div>
          <div class="d-flex filters-wrapper">
            <AppSearchInput
              class="mb-6 mr-4"
              search-placeholder="Wyszukaj użytkowników"
              @search="filterUsers({ query: $event })"
            />

            <v-autocomplete
              :value="selectedFilters.roleIds"
              :items="filtersOptions.roles"
              placeholder="Role"
              v-bind="staticData.props.multiselect"
              item-text="label"
              item-value="id"
              background-color="white"
              class="mr-2 width-220"
              @input="filterUsers({ roleIds: $event })"
            >
              <template #selection="{ item, index }">
                <AppMultiselectChoices
                  :index="index"
                  :array-length="selectedFilters.roleIds.length"
                  :label="item.label"
                />
              </template>
            </v-autocomplete>
          </div>

          <SettingsUsersTable />
        </div>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import AppSearchInput from '@/components/UI/AppSearchInput.vue';
import SettingsUsersTable from '@/components/Settings/SettingsUsersTable.vue';
import AppMultiselectChoices from '@/components/UI/AppMultiselectChoices.vue';
import props from '@/helpers/componentsProps';

export default {
  components: {
    AppViewLayout,
    AppSearchInput,
    SettingsUsersTable,
    AppMultiselectChoices,
  },
  data: () => ({
    staticData: { props },
  }),

  computed: {
    ...mapState('filters', [
      'filtersOptions',
      'selectedFilters',
    ]),
  },

  methods: {
    ...mapActions('users', [
      'fetchUsers',
    ]),
    ...mapActions('dialog', [
      'showDialog',
    ]),

    ...mapActions('filters', [
      'setFilters',
    ]),

    filterUsers(filter) {
      this.setFilters(filter)
        .then(() => {
          this.fetchUsers();
        });
    },

    showCreateUserModal() {
      this.showDialog({
        header: 'Dodawanie nowego użytkownika',
        text: 'Wypełnij poniższe dane aby dodać nowe konto.',
        component: 'CreateUser',
      });
    },
  },
};
</script>
